export class Document {
    uploadedDocumentName: string;
    internalDocumentName: string;
    isUploaded: boolean;
    file: File;
    idx: number;
}

export class UserDocument extends Document {
    userDocumentID: number;
    userID: number;
}
